var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRecent = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#B3B3B3;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0h24v24H0V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.2,3C8.2,2.9,4,6.9,4,12H2.2c-0.5,0-0.7,0.5-0.4,0.9l2.8,2.8c0.2,0.2,0.5,0.2,0.7,0l2.8-2.8 C8.5,12.5,8.2,12,7.8,12H6c0-3.9,3.2-7.1,7.1-7c3.7,0.1,6.9,3.2,6.9,6.9c0,3.9-3.1,7.1-7,7.1c-1.6,0-3.1-0.5-4.3-1.5 c-0.4-0.3-1-0.3-1.3,0.1C7,18,7,18.7,7.5,19.1C9,20.3,10.9,21,13,21c5.1,0,9.1-4.2,9-9.3C21.9,7,17.9,3.1,13.2,3z M12.7,8 C12.3,8,12,8.3,12,8.8v3.7c0,0.4,0.2,0.7,0.5,0.9l3.1,1.9c0.4,0.2,0.8,0.1,1-0.3c0.2-0.4,0.1-0.8-0.3-1l-2.9-1.7V8.7 C13.5,8.3,13.2,8,12.7,8z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRecent, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/recent.bff3139d.svg";
export { ForwardRef as ReactComponent };